
@if (loaded) {
    <div>
      <div class="main">
      
        <calsoft-layout [value]="'1'"></calsoft-layout>
      </div>
    </div>
  }
  
  
  